import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../Api';

// Upload file to S3
export const uploadFileToS3 = createAsyncThunk(
  'homestead/uploadFile',
  async (file, { rejectWithValue }) => {
    try {
      const formData = new FormData();
      formData.append('file', file);
      
      const response = await api.post('/campaign-lead-service/supporting-documents/upload/s3', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'File upload failed');
    }
  }
);

// Submit homestead documents
export const submitHomesteadDocuments = createAsyncThunk(
  'homestead/submitDocuments',
  async (payload, { rejectWithValue }) => {
    try {
      const response = await api.post('/admin-service/homestead/file', payload);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.detail  || 'Homestead submission failed');
    }
  }
);

const homesteadSlice = createSlice({
  name: 'homestead',
  initialState: {
    uploading: false,
    submitting: false,
    uploadError: null,
    submitError: null,
    uploadProgress: 0,
    lastUploadResult: null,
    submitResult: null,
  },
  reducers: {
    clearErrors: (state) => {
      state.uploadError = null;
      state.submitError = null;
    },
    clearResults: (state) => {
      state.lastUploadResult = null;
      state.submitResult = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Upload file to S3
      .addCase(uploadFileToS3.pending, (state) => {
        state.uploading = true;
        state.uploadError = null;
        state.uploadProgress = 0;
      })
      .addCase(uploadFileToS3.fulfilled, (state, action) => {
        state.uploading = false;
        state.lastUploadResult = action.payload;
        state.uploadProgress = 100;
      })
      .addCase(uploadFileToS3.rejected, (state, action) => {
        state.uploading = false;
        state.uploadError = action.payload;
        state.uploadProgress = 0;
      })
      // Submit homestead documents
      .addCase(submitHomesteadDocuments.pending, (state) => {
        state.submitting = true;
        state.submitError = null;
      })
      .addCase(submitHomesteadDocuments.fulfilled, (state, action) => {
        state.submitting = false;
        state.submitResult = action.payload;
      })
      .addCase(submitHomesteadDocuments.rejected, (state, action) => {
        state.submitting = false;
        state.submitError = action.payload;
      });
  },
});

export const { clearErrors, clearResults } = homesteadSlice.actions;
export default homesteadSlice.reducer;